import React, { useEffect, useState } from "react";
import { CheckCircle2, AlertTriangle, Loader2, RefreshCw } from "lucide-react";
import api from "../../api";

export const StripeStatusPanel = () => {
  const [st, setSt] = useState(null);
  const load = () => { setSt(null); api.get("/admin/stripe-status").then(({ data }) => setSt(data)).catch(() => setSt({ error: true })); };
  const [checking, setChecking] = useState(false);
  useEffect(() => { load(); }, []);
  const check = async () => {
    setChecking(true);
    try { const { data } = await api.post("/admin/stripe-connect-check"); setSt(data); } finally { setChecking(false); }
  };
  if (!st) return <div className="rounded-xl bg-[#f6f8fb] p-4 text-sm text-[#5a6b80] flex items-center gap-2"><Loader2 size={15} className="animate-spin" /> Checking Stripe…</div>;
  if (st.error) return null;
  const ok = st.configured && st.connect_enabled;
  const off = st.configured && st.connect_enabled === false;
  return (
    <div className={`rounded-xl border p-4 text-sm ${ok ? "bg-[#f0fdf4] border-green-100" : "bg-amber-50 border-amber-100"}`} data-testid="stripe-status">
      <div className="flex items-start justify-between gap-3">
        <div className="space-y-1">
          <p className="font-semibold text-[#16243b] flex items-center gap-1.5">
            {ok ? <CheckCircle2 size={16} className="text-green-600" /> : <AlertTriangle size={16} className="text-amber-600" />}
            {!st.configured ? "Stripe not configured" : <>Stripe <span className={`rounded-full px-2 py-0.5 text-[11px] uppercase ${st.mode === "live" ? "bg-green-600 text-white" : "bg-amber-500 text-white"}`} data-testid="stripe-mode">{st.mode}</span> {st.account_name && `· ${st.account_name}`}</>}
          </p>
          {st.configured && (
            <p className="text-[#5a6b80]" data-testid="stripe-connect-state">
              Stripe Connect (automatic split payments): {st.connect_enabled ? <strong className="text-green-700">enabled</strong> : st.connect_enabled === false ? <strong className="text-amber-700">not enabled</strong> : <strong className="text-[#5a6b80]">not checked yet — press Check Connect</strong>}
            </p>
          )}
          {off && (
            <p className="text-xs text-amber-800">{st.connect_error ? `${st.connect_error} ` : ""}In Stripe ({st.mode} mode): open <a href="https://dashboard.stripe.com/connect" target="_blank" rel="noreferrer" className="underline">dashboard.stripe.com/connect</a> → Get started → choose <strong>Platform</strong> → Express accounts → finish the platform profile, then press Check Connect.</p>
          )}
          <p className="text-xs text-[#5a6b80]" data-testid="stripe-business-counts">
            Businesses: <strong>{st.businesses_connected}</strong> on Connect (auto split) · <strong>{st.businesses_onboarding}</strong> started onboarding · <strong>{st.businesses_platform}</strong> paid via platform (manual payouts)
          </p>
        </div>
        <button type="button" onClick={check} disabled={checking} title="Test Stripe Connect now" data-testid="stripe-connect-check"
          className="shrink-0 gp-btn-outline rounded-full px-3 py-1.5 text-xs font-medium inline-flex items-center gap-1.5 disabled:opacity-50">
          {checking ? <Loader2 size={13} className="animate-spin" /> : <RefreshCw size={13} />} Check Connect
        </button>
      </div>
    </div>
  );
};
